<template>
  <div class="wrapper">
    <div class="out-card">
      <div class='tab-wrap-inside'>
        <div class="tab-btn">
          <span :class="statisticPeriod === 'month' ? 'active' : ''" @click="changeStats('month')">当月</span>
          <span :class="statisticPeriod === 'season' ? 'active' : ''" @click="changeStats('season')">季度</span>
          <span :class="statisticPeriod === 'annual' ? 'active' : ''" @click="changeStats('annual')">年度</span>
        </div>
      </div>
      <div class="out-total">
        <p class="total-name">销项总额（元）</p>
        <p class="total-money">{{convertNumber(outStats.totalAmount) || '0.00'}}</p>
      </div>
      <div class="out-detail">
        <div>
          <p>税额（元）</p>
          <p>{{convertNumber(outStats.totalTaxAmount)}}</p>
        </div>
        <div>
          <p>开票张数（张）</p>
          <p>{{outStats.totalNum || 0}}</p>
        </div>
      </div>
    </div>
    <Chart :data-source="0"/>
    <!-- <div class="out-statistics">
      <div>
        <h6>当月未开发票数量</h6>
        <p>
          {{applyInvoiceCount.agentSettlementQuantity}}
        </p>
      </div>
      <div>
        <h6>当月未开发票金额</h6>
        <p>
          {{convertNumber(applyInvoiceCount.agentSettlementAmountWithTax)}}
        </p>
      </div>
      <div>
        <h6>当月开票失败数量</h6>
        <p>
          {{applyInvoiceCount.createInvoiceFailQuantity}}
        </p>
      </div>
      <div>
        <h6>当月红冲发票数量</h6>
        <p>
          {{applyInvoiceCount.redInvoiceQuantity}}
        </p>
      </div>
    </div> -->
    <div class="blank-warn">
      <h6>空白发票预警</h6>
      <div>
        <div>
          <h6>专用发票</h6>
          <p style="color: #000">
            {{blankInvoiceCount.specialInvQuantity}}
          </p>
        </div>
        <div>
          <h6>普通发票</h6>
          <p style="color: #000">
            {{blankInvoiceCount.generalInvQuantity}}
          </p>
        </div>
        <div>
          <h6>电普发票</h6>
          <p style="color: #000">
            {{blankInvoiceCount.electronicInvQuantity}}
          </p>
        </div>
        <div>
          <h6>电专发票</h6>
          <p style="color: #000">
            {{blankInvoiceCount.electronicSpecialInvQuantity}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Notify
} from 'vant'
import { invoiceRequest } from '@services'
import {
  ConvertNumber
} from '@utils/basicUtil'
import Chart from './Chart'
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    Chart
  },
  props: {},
  data () {
    return {
      statisticPeriod: 'month',
      outStats: {
        totalAmount: 0,
        totalNum: 0,
        totalTaxAmount: 0
      },
      blankInvoiceCount: {
        specialInvQuantity: 0,
        generalInvQuantity: 0,
        electronicInvQuantity: 0,
        invoiceWarn: 0,
        electronicSpecialInvQuantity: 0
      },
      applyInvoiceCount: {
        agentSettlementAmountWithTax: 0,
        agentSettlementQuantity: 0,
        createInvoiceFailQuantity: 0,
        redInvoiceQuantity: 0
      }
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.getStatistics()
  },
  activated () {},
  updated () {},
  methods: {
    changeStats (period) {
      this.statisticPeriod = period
      if (period === 'month') {
        this.outStats = this.dataSource.currMonthStatistics
      }
      if (period === 'season') {
        this.outStats = this.dataSource.quarterStatistics
      }
      if (period === 'annual') {
        this.outStats = this.dataSource.yearStatistics
      }
    },
    convertNumber (data) {
      return ConvertNumber(data) || '0.00'
    },
    async getStatistics () {
      const data = await invoiceRequest.statistics.getStatistics({})
      if (data.success) {
        this.dataSource = data.result
        this.blankInvoiceCount = { ...this.blankInvoiceCount, ...data.result.blankInvoiceCount }
        this.applyInvoiceCount = { ...this.applyInvoiceCount, ...data.result.apply }
        this.changeStats('month')
      } else {
        if (data.success === false) {
          Notify({ type: 'danger', message: data.message })
        }
      }
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"/>
